import React, { useCallback, useContext, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import auth from 'api/auth';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import useCountdown from '../../hooks/useCountdown';
import { SUCCESS_MESSAGES } from 'request-responses';
import { getEmailOrPhoneForLoginOrRegister, getResolveUrl } from 'utils';
import HelmetWrapper from 'components/HelmetWrapper';
import { FORGOT_PASSWORD_ROUTE } from 'data/global';
import EmailOrPhoneFieldWrapper from 'components/EmailOrPhoneFieldWrapper';
import { EmailOrPhoneForm } from 'models/AuthBody';

import './ForgotPassword.styles.scss';

const ForgotPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const { popServerError, popSuccess } = useContext(PopNotificationsContext);

  const { timeLeft, startCountdown } = useCountdown();

  const { t } = useTranslation();

  const onSubmit = useCallback(
    async ({ email, emailOrPhone }: EmailOrPhoneForm) => {
      const requestData = getEmailOrPhoneForLoginOrRegister({
        email,
        emailOrPhone,
      });

      try {
        setLoading(true);
        await auth.forgotPassword(requestData);
        startCountdown();
        popSuccess(t(SUCCESS_MESSAGES.FORGOT_PASSWORD));
      } catch (er) {
        popServerError(er);
      }

      setLoading(false);
    },
    [popServerError, popSuccess, startCountdown, t],
  );

  const helmetUrl = getResolveUrl(FORGOT_PASSWORD_ROUTE);
  const title = 'Forgot your Resolve password?';
  const description =
    'Did you forget your password? Send request for changing to Resolve.';

  return (
    <>
      <HelmetWrapper title={title} description={description} url={helmetUrl} />

      <h1>{t('forgotPassword')}</h1>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, valid, submitting }) => (
          <form className="auth-login" onSubmit={handleSubmit}>
            <EmailOrPhoneFieldWrapper />
            <div className="actions">
              <Button
                type="submit"
                disabled={loading || timeLeft > 0 || !valid || submitting}
                data-loading={loading}
              >
                {timeLeft === 0
                  ? t('resetPassword')
                  : t('waitFor', { count: timeLeft })}
              </Button>
            </div>
          </form>
        )}
      />
    </>
  );
};

export default ForgotPassword;
